import * as React from 'react';
import { Field, reduxForm, change } from 'redux-form';
//import DEform from '../forms/DEform';
import styles from './deFormStyles';
//import saveSettings from '../container/SettingsContainer/saveSettings';

import { TouchableOpacity } from 'react-native';
import { H2, CardItem, Container, Header, InputGroup, Content, Text, Label, Item, Input, Icon, Toast, Form, Spinner, View, Left, Right, Body, Button, Title, Card, Separator, H3 } from 'native-base';

//import * as _ from 'lodash';

import customValidate from './validators';
import Picker from '../components/picker';

import { textInput, moneyInput, renderPicker, renderDateField, renderCheckbox, percentInput, numberInput } from './renderedComponents';

//import CalCalDataApi  from '../api/CalCalDataApi';

const syncValidate = values => {
	let errors = {};

	if (!values.businessName) {
		errors.businessName = 'Required';
	} else if (values.businessName.length > 25) {
		errors.businessName = 'Must be 25 characters or less';
	}
	if (parseInt(values.defaultInvoiceTerm).toString() != values.defaultInvoiceTerm) errors.defaultInvoiceTerm = 'Must be a whole number of days';

	return errors;
};

function asyncValidate(values, dispatch, props, field) {
	return new Promise((resolve, reject) => {
		/*if(field == 'defaultInvoiceTerm'){
				//numbers
				var value= Number(values[field]);
				var betterVal = parseInt(isNaN(value)?0:value).toString();
				dispatch(change('DEform', field, betterVal));
			}*/
		resolve();
	});
}

const formatPerc = value => value + '%'; //to display
const parsePerc = value => parseFloat(isNaN(value) ? 0 : value); //to store
const parseNum = value => (parseInt(value).toString() == 'NaN' ? '0' : parseInt(value).toString());
const upper = value => value && value.toUpperCase();

class busDetailsForm extends React.Component {
	constructor(props) {
		super(props);

		this.initialState = {};
		this.state = this.initialState;
	}
	/*
	_changeFormVal(field, val) {
		console.log('setting ', field, val);
		this.props.dispatch(change('BusDetails.General', field, val));
	}
*/
	renderForm(type) {
		switch (type) {
			case 'About You':
				return (
					<View>
						<Card>
							<Separator>
								<H3>🏭 Your Business</H3>
							</Separator>
							<Field name="businessName" labelType="inline" label="👤" placeholder="Your Name" component={textInput} />
							<Field name="tradeName" labelType="inline" label="🚩" placeholder="Trade Name" component={textInput} />
							<Field name="businessType" labelType="inline" label="🏡" placeholder="Nature of Business" component={textInput} />
							{this.props.initialValues?.taxType == 'ltd' && <Field name="companyNumber" labelType="inline" label="🔢" placeholder="Company Number" component={textInput} />}
						</Card>
						<Card>
							<Separator>
								<H3>🏢 Address</H3>
							</Separator>
							<Field name="address1" labelType="inline" label=" " placeholder="Address" component={textInput} />
							<Field name="address2" labelType="inline" label=" " component={textInput} />
							<Field name="city" labelType="inline" label=" " placeholder="Town" component={textInput} />
							<Field name="postcode" labelType="inline" label=" " validate={[customValidate]} normalize={upper} placeholder="Postcode" component={textInput} />
						</Card>
						<Card>
							<Separator>
								<H3>📞 Contact Details</H3>
							</Separator>
							<Field name="tel" labelType="inline" validate={[customValidate]} keyboardType={'phone-pad'} label="Tel" component={textInput} />

							<Field name="email" labelType="inline" validate={[customValidate]} keyboardType={'email-address'} label="Email" component={textInput} />
							<Field name="web" labelType="inline" label="Web" component={textInput} />
						</Card>
					</View>
				);

			case 'Settings':
				return (
					<>
						<Card style={{ paddingBottom: 5 }}>
							<Separator>
								<H3>General Settings</H3>
							</Separator>
							<Field name="invoicePrefix" textAlign="right" labelType="inline" labelWidth="50%" label="Prefix for Invoice Numbers" placeholder="Eg. IN..." component={textInput} />
							<Field
								name="defaultInvoiceTerm"
								labelType="inline"
								labelWidth="50%"
								textAlign="right"
								selectTextOnFocus
								normalize={parseNum}
								keyboardType={'numeric'}
								placeholder="Payment term in days"
								postScript="days"
								label="Default Invoice Term"
								component={textInput}
							/>
							<Field name="vatRegistered" disabled labelType="inline" label="VAT Registered" component={renderCheckbox} />
							<Field name="legalFormOfBusiness" labelType="inline" labelWidth="50%" label="Legal Form of Business" component={textInput} />
						</Card>
						<Card>
							<Separator>
								<H3>CalCal Start</H3>
							</Separator>
							<Field disabled name="accountingStartDate" label="CalCal Start Date" labelType="inline" labelWidth={180} component={renderDateField} />
						</Card>
					</>
				);

			case 'VAT':
				return (
					<Card>
						<Field name="vatRate" labelType="inline" label="Default VAT Rate" component={percentInput} />
						<Field name="vatNumber" labelType="inline" label="Your VAT Number" component={textInput} textAlign="right" labelWidth="50%" />

						<Field name="vatDDAccount" label="Direct Debit from Account" component={renderPicker} iosHeader="Select account" mode="dropdown">
							{this.props.accounts.map((item, i) => (
								<Picker.Item key={i} label={item.nickName} value={item.id} />
							))}
						</Field>
					</Card>
				);
			case 'Tax':
				return (
					<Card>
						<Separator>
							<H3>Self-Employment Info</H3>
						</Separator>
						<Field name="utr" textAlign="right" labelType="inline" labelWidth={210} validate={[customValidate]} label="Unique Taxpayer Ref(UTR)" component={textInput} keyboardType={'numeric'} />
						<Field name="niNumber" textAlign="right" labelType="inline" labelWidth={210} validate={[customValidate]} normalize={upper} label="National Insurance No" component={textInput} />
						<Field name="dob" label="Your DOB" labelType="inline" displayFormat="DD/MM/YYYY" niIcon={true} component={renderDateField} />
					</Card>
				);
		}
	}

	render() {
		const { handleSubmit, pristine, reset, submitting } = this.props;
		//gets given props.handleSubmit. Need to call handleSubmit(submitFn)

		//label floating, inline, stacked
		return <Form onSubmit={this.props.handleSubmit}>{this.renderForm(this.props.formType)}</Form>;
	}
}

export default reduxForm({
	form: 'BusDetails.General',
	validate: syncValidate,
	asyncValidate,
	asyncBlurFields: ['defaultInvoiceTerm', 'vat', 'payable', 'paid']
})(busDetailsForm);
